import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=13154cd6&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"
import style0 from "./Tables.vue?vue&type=style&index=0&id=13154cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13154cd6",
  null
  
)

export default component.exports